import { WidgetSettings } from '@gsc/types'

export enum EventType {
  User = 'user',
  Session = 'session',
  PageView = 'pageView',

  Show = 'show',
  Close = 'close',
  Hide = 'hide', // hide by targeting, without user interaction

  SubmitWidget = 'submit',
  OpenUrl = 'openUrl',
  ShowWidget = 'showWidget',
  CopyToClipboard = 'copyToClipboard',

  AddToCart = 'addToCart',
  ApplyCoupon = 'applyCoupon',
}

export const ActionEventTypes = [
  EventType.SubmitWidget,
  EventType.OpenUrl,
  EventType.ShowWidget,
  EventType.CopyToClipboard,
  EventType.ApplyCoupon,
  EventType.AddToCart,
]

export class Event {
  constructor(public type: string, public widget?: Partial<WidgetSettings>, private data?: any) {}

  public prettyData(): any {
    const data = this.getData()
    if (this.type === EventType.OpenUrl) {
      return data.url
    }
    if (this.type === EventType.ShowWidget) {
      return data.widgetId
    }
    return data
  }

  public get key(): string {
    // unique event key
    const dataKey = JSON.stringify(this.data || {})
    const widgetKey = this.widget ? this.widget.id : null
    return `${this.type}/${dataKey}/${widgetKey}`
  }

  public getData(): any {
    return JSON.parse(JSON.stringify(this.data || {}))
  }

  public isAction(): boolean {
    return ActionEventTypes.includes(this.type as EventType)
  }
}
